<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="1100px"
      scrollable
      @input="handleDialog($event)">
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          color="primary"
          depressed
          :rounded="rounded"
          :outlined="outlined"
          :disabled="disabled"
          v-on="on">
          พิมพ์บาร์โค้ด
        </v-btn>
      </template>
      <v-card v-if="item">
        <v-card-title>
          <div class="primary--text">
            ตั้งค่าบาร์โค้ด
          </div>
          <v-spacer />
          <v-btn
            color="#A9A9A9"
            x-small
            icon
            @click="setDialog(false)">
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-wrap flex-md-nowrap overflow-auto h-100">
            <BarcodeSettingForm
              :pos1.sync="pos1"
              :pos2.sync="pos2"
              :pos3.sync="pos3"
              :show-barcode-number.sync="showBarcodeNumber"
              :col.sync="col"
              :row.sync="row"
              :my.sync="my"
              :mx.sync="mx"
              :omy.sync="omy"
              :omx.sync="omx"
              :imy.sync="imy"
              :page-size.sync="pageSize"
              :font-size.sync="fontSize"
              :copied.sync="copied" />
            <v-spacer
              v-if="!$vuetify.breakpoint.smAndDown" />
            <div
              v-if="!$vuetify.breakpoint.smAndDown"
              class="mx-8 mt-10">
              <v-divider vertical />
            </div>
            <div class="d-flex flex-column align-center mx-auto">
              <div class="mb-6 mt-1">
                ตัวอย่าง
              </div>
              <div
                id="barcodePreview"
                class="modern-scrollbar flex-grow-1 overflow-auto">
                <BarcodePaper
                  :items="[item]"
                  :width="pageSize.width"
                  :height="pageSize.height"
                  :aspect-ratio="previewRatio"
                  :elements="elements"
                  :col="col"
                  :row="row"
                  :my="my"
                  :mx="mx"
                  :omy="omy"
                  :omx="omx"
                  :imy="imy"
                  :font-size.sync="fontSize"
                  :show-barcode-number="showBarcodeNumber"
                  class="barcode-preview" />
              </div>
              <div class="d-flex justify-center align-center gap-6">
                <v-btn
                  color="primary"
                  icon
                  @click="setPage(page-1)">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div>{{ page }} จาก {{ itemChunked.length }}</div>
                <v-btn
                  color="primary"
                  icon
                  @click="setPage(page+1)">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <BarcodePreview
            :items="itemChunked"
            :elements="elements"
            :width="pageSize.width"
            :height="pageSize.height"
            :col="col"
            :row="row"
            :my="my"
            :mx="mx"
            :omy="omy"
            :omx="omx"
            :imy="imy"
            :font-size.sync="fontSize"
            :show-barcode-number="showBarcodeNumber"
            @submit="submit()" />
          <v-btn
            class="ml-6 px-4"
            color="primary"
            rounded
            text
            @click="setDialog(false)">
            ยกเลิก
          </v-btn>
          <v-btn
            class="px-4"
            color="primary"
            depressed
            rounded
            @click="submit()">
            พิมพ์
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import printJS from 'print-js'
import vuetify from '@/plugins/VuetifyProduct'
import BarcodePaper from './BarcodePaper.vue'
import BarcodePreview from './BarcodePreview.vue'
import BarcodeSettingForm from './BarcodeSettingForm.vue'

export default {
  components: { BarcodePaper, BarcodePreview, BarcodeSettingForm },
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    rounded: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      pageSize: {
        width: 209,
        height: 296
      },
      fontSize: 10,
      pos1: 'name',
      pos2: 'barcode',
      pos3: 'price',
      showBarcodeNumber: true,
      col: 2,
      row: 3,
      page: 1,
      my: 6,
      mx: 6,
      omy: 6,
      omx: 6,
      imy: 6,
      width: 50,
      copied: 1
    }
  },
  computed: {
    ...mapGetters({
      settingBarcode: 'local/settingBarcode'
    }),
    settingAll () {
      return {
        pageSize: {
          width: this.pageSize.width,
          height: this.pageSize.height
        },
        fontSize: this.fontSize,
        pos1: this.pos1,
        pos2: this.pos2,
        pos3: this.pos3,
        showBarcodeNumber: this.showBarcodeNumber,
        col: this.col,
        row: this.row,
        page: this.page,
        my: this.my,
        mx: this.mx,
        omy: this.omy,
        omx: this.omx,
        imy: this.imy,
        width: this.width,
        copied: this.copied
      }
    },
    previewRatio () {
      return 120 / this.pageSize.width
    },
    elements () {
      return [this.pos1, this.pos2, this.pos3]
    },
    itemsCopied () {
      const items = []
      this.items.forEach((item) => {
        this.$_.times(this.copied, () => {
          items.push(item)
        })
      })
      return items
    },
    itemChunked () {
      return this.$_.chunk(
        this.$_.chunk(this.itemsCopied, this.col),
        this.row
      )
    },
    item () {
      return this.itemChunked[this.page - 1]
    }
  },
  watch: {
    settingAll: {
      deep: true,
      handler (newValue) {
        this.setSettingBarcode(newValue)
      }
    }
  },
  methods: {
    ...mapActions({
      setSettingBarcode: 'local/setSettingBarcode'
    }),
    setDialog (dialog = false) {
      this.dialog = dialog
    },
    submit () {
      const items = this.itemChunked
      const col = this.col
      const row = this.row
      const height = this.pageSize.height
      const width = this.pageSize.width
      const my = this.my
      const mx = this.mx
      const omy = this.omy
      const omx = this.omx
      const imy = this.imy
      const el = document.createElement('div')
      const fontSize = this.fontSize
      const showBarcodeNumber = this.showBarcodeNumber
      const elements = this.elements
      const vm = new (Vue.extend(BarcodePaper))({
        el,
        propsData: {
          height,
          width,
          col,
          row,
          my,
          mx,
          omy,
          omx,
          imy,
          items,
          fontSize,
          showBarcodeNumber,
          elements
        },
        vuetify
      })
      vm.$mount(el)
      vm.$nextTick(() => {
        const html = vm.$el.innerHTML
        const div = document.createElement('div')
        div.innerHTML = html.trim()
        let size = ''
        const fixMargin = 0
        if (width && height) {
          size = `${Math.floor(width) - fixMargin}mm ${Math.floor(height) - fixMargin}mm`
        }
        printJS({
          printable: div.innerHTML,
          type: 'raw-html',
          honorColor: true,
          css: [
            'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
          ],
          style: `
            html { 
              font-family: 'prompt', sans-serif; 
              -webkit-print-color-adjust: exact; 
            }
            @page {
              size: ${size};
              margin: 0;
            }
            body {
              font-family: prompt;
              line-height: 1.5;
              width: 100%;
              height: 100%;
              margin: 0;
              padding: 0;
            }
            * {
              color: #000000;
              box-sizing: border-box;
            }
          `,
          targetStyles: ['*']
        })
        this.$emit('input', true)
      })
    },
    setPage (page = 1) {
      if (page > 1) {
        this.page = page > this.itemChunked.length ? this.itemChunked.length : page
      } else {
        this.page = 1
      }
    },
    handleDialog (dialog) {
      if (dialog) {
        const localItem = JSON.parse(window.localStorage.getItem('local:product'))
        if (!this.$_.isEmpty(localItem.local.settingBarcode)) {
          const { settingBarcode } = localItem.local
          this.pageSize.width = settingBarcode.pageSize.width
          this.pageSize.height = settingBarcode.pageSize.height
          this.fontSize = settingBarcode.fontSize
          this.pos1 = settingBarcode.pos1
          this.pos2 = settingBarcode.pos2
          this.pos3 = settingBarcode.pos3
          this.showBarcodeNumber = settingBarcode.showBarcodeNumber
          this.col = settingBarcode.col
          this.row = settingBarcode.row
          this.page = 1
          this.my = settingBarcode.my
          this.mx = settingBarcode.mx
          this.omy = settingBarcode.omy
          this.omx = settingBarcode.omx
          this.imy = settingBarcode.imy
          this.width = settingBarcode.width
          this.copied = settingBarcode.copied
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .barcode-preview {
    background-color: #F6F6F6;
  }
</style>
